import { atomWithStorage } from "jotai/utils";
import { storageKey } from "app/utils/storageKeys";
import { CartItemT } from "app/api/cart/cart.type";

const cartList = atomWithStorage<CartItemT[]>(storageKey.cart, []);

export { cartList };
